import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { media } from '../../../../assets/styles'
import { colors } from 'app-v2/design-systems/theme/colors'
import { fonts } from 'app-v2/design-systems/typography/fonts'

export const TPKDone = () => {
    const intl = useIntl()
    return (
        <StyledEndedContainer>
            <StyledEndedContainerTitle>
                {intl.formatMessage({ id: 'tupreferesking.home.done.1' })}
            </StyledEndedContainerTitle>
            <StyledEndedContainerText>
                {intl.formatMessage({ id: 'tupreferesking.home.done.2' })}
            </StyledEndedContainerText>
        </StyledEndedContainer>
    )
}

export const StyledEndedContainer = styled.div`
    padding: 0 16px;
    ${media.large`padding: 0 48px;`}
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const StyledEndedContainerText = styled.p`
    font-family: ${fonts.flameSansRegular};
    font-size: 18px;
    line-height: 1.5;
    color: ${colors.bbqBrown};
    text-align: center;
`

export const StyledEndedContainerTitle = styled.h2`
    font-family: ${fonts.flameRegular};
    font-size: 24px;
    line-height: 1.5;
    color: ${colors.bbqBrown};
    text-align: center;
`
